import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { appCodeRules, initialAppCodeForm } from "./Constant";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";

const AppCodes = () => {
  const [appCodeList, setAppCodeList] = useState([initialAppCodeForm]);
  const [errorForm, setErrorForm] = useState([]);

  const fetchData = async () => {
    const response = await CommmonService.getAllAppCodes();
    if (!response?.status) return;
    const finalData = response?.data?.length ? response?.data : [initialAppCodeForm];
    setAppCodeList(finalData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onChange = (index, name, value) => {
    setAppCodeList((prev) =>
      prev.map((d, idx) => (idx !== index ? d : { ...d, [name]: value }))
    );
  };

  const deleteRow = (index) => {
    setAppCodeList((prev) => {
      if (prev[index].id) prev[index].deleted = 1;
      else prev.splice(index, 1);
      return [...prev];
    });
  };

  const addRow = () => {
    setAppCodeList((prev) => [...prev, JSON.parse(JSON.stringify(initialAppCodeForm))]);
  };

  const onSubmit = async () => {
    let flag = 0;
    const errorArray = appCodeList.map((data) =>
      data.deleted ? {} : Validation(data, appCodeRules)
    );
    setErrorForm(errorArray);

    for (const errObj of errorArray)
      for (const key in errObj)
        if (errObj[key]) {
          flag = 1;
          break;
        }

    if (flag) return;

    let duplicateErr = [];
    let codeFlag = 0;
    appCodeList.forEach((d) => {
      if (!d.deleted) {
        if (!duplicateErr.includes(d.appCode)) duplicateErr.push(d.appCode);
        else codeFlag++;
      }
    });

    if (codeFlag) {
      toastr.error("Duplicate is not allowed in App Code");
      return;
    }

    const formObj = {
      appCodes: appCodeList,
    };

    const response = await CommmonService.updateAppCodeData(formObj);
    if (!response?.status) {
      toastr.error(response?.message);
      return;
    }
    toastr.success(response?.message || "Updated successfully");
    fetchData();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          { name: "Manage App Codes", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />

      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Manage App Codes</h3>
            </div>
            <div className="w-100">
              <div className="table-responsive drillingPlan-plannedEdit">
                <table className="table table-bordered mb-3">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">App Code</th>
                      <th scope="col">Url</th>
                      <th scope="col">Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appCodeList.length ? (
                      appCodeList.map((x, index) => {
                        return x.deleted ? null : (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td>
                              <input
                                value={x.appCode}
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                name="appCode"
                                type="text"
                                className="form-control"
                              />
                              <span className="small text-danger">
                                {errorForm[index]?.appCode}
                              </span>
                            </td>
                            <td>
                              <input
                                value={x.url}
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                name="url"
                                type="text"
                                className="form-control"
                              />
                              <span className="small text-danger">
                                {errorForm[index]?.url}
                              </span>
                            </td>
                            <td>
                              {appCodeList?.length > 1 ? (
                                <div className="actionIconsGroup">
                                  <CustomTooltip tooltip="Delete">
                                    <a
                                      href
                                      className="icons text-danger pointer font-20"
                                      onClick={() => deleteRow(index)}
                                    >
                                      <FiMinusCircle />
                                    </a>
                                  </CustomTooltip>
                                </div>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" align="center"></td>
                      </tr>
                    )}
                    <tr>
                      <td colSpan="10">
                        <CustomTooltip tooltip="Add Row">
                          <Button className="addRowPluseIcon" onClick={addRow}>
                            <FiPlusCircle />
                          </Button>
                        </CustomTooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="text-center">
                <Button className="ml-2" onClick={() => onSubmit()} variant="primary">
                  Update
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppCodes;
